// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__mSDre","rootSmall":"AddTileButton_rootSmall__WBWzH"};